const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'tableSimple',
		'table'
	],

	config: {
		isSortable: true,
		lazyloadStepSize: 25,
		preventSortOfField: {
			tags: true,
		},
		buttonContext: 'prompt',
		renderEmptyBeforReady: false,
		showHead: false,
		showInsertButton: false,
		showColorCodedRows: true,
		showAllBorders: false,
		showDelimiterBorders: true,
		inline: true,
		maxNrOfExportElements: 500000,
		privilegeBase: 'mblx_prompts',
	},

	model: {
		resourceFilters: {
			order: [{
				fieldCode: 'promptID',
				direction: 'asc'
			}],
		},
		productNumber: null, // since the list of prompts is directly influenced by the product number it will be saved here for later use.
	},

	methods: {

		prepare(){
			if(!this.model.controller){
				this.closest('templates_mblx_products_promptAssociations_promptChooser_controller', c => this.model.controller = c)
			}

			let modal
			this.closest('base_modal_modal', m => modal = m)
			if(!modal) return;

			const {
				productNumber = null,
			} = (modal.model || {}).decisionScope || {}

			this.model.productNumber = productNumber
		},

		sanitizeResourceFilters: function(storage, resourceFilters, actionKey){

			if(actionKey === 'refreshResources'){
				resourceFilters = resourceFilters || {}
				resourceFilters.baseFilters = resourceFilters.baseFilters || {}
				resourceFilters.productNumber = this.model.productNumber || null
				resourceFilters.filters = resourceFilters.filters || {}
			}
			return resourceFilters
		},

		// TODO: product number mandatory?!
		loadResourcesGranted: function(storage, resourceFilters, actionKey, fieldCode, attachTriggerOptions){
			var nrOfFilters = utils.collectionSize((resourceFilters || {}).filters)
			return actionKey !== 'refreshResources' || nrOfFilters > 1 || (nrOfFilters > 0 && resourceFilters.tags_tagConnection === undefined);
		},

		addEntity: function(entity){
			// add entity to dom if possible
			if(this.config.isReady && (this.model.$table || []).length > 0){
				this.model.$table.append(this.include('./row', { config: this.config, resourceData: entity, model: this.model }));
			}
		},

		async showEdit(rowID, rowData, buttonMode){
			if(!this.model.controller){
				console.error('MISSING CONTROLLER')
				return
			}

			const promptID = ((rowData || {}).attributes || {}).promptID
			if(promptID){
				await this.model.controller.decideClosest({
					decision: 'prompt',
					promptID: promptID,
				})
			} else {
				await this.model.controller.decideClosest({
					decision: 'outstanding',
					promptID: null,
				})
			}
		},

		customClickHandler: function(event){
			var bubble = $(event.target).closest('.bubble')
			var tagsColumn = $(event.target).closest('.fieldOf_tags')
			if(bubble.length > 0 && tagsColumn.length > 0){
				var tagKey = bubble.data('tagKey');
				var tagParts = String(tagKey || '').split('_') || [];
				var categoryID = tagParts[0] || 0
				var categoryDataID = tagParts[1] || 0
				if(categoryID && categoryDataID){
					this.triggerClosest('colTagsBubbleSelected', {
						categoryID,
						categoryDataID
					}, 'templates_mblx_products_promptAssociations_promptChooser_controller')
					return true;
				}
			}

			return false;
		},

		onAfterLazyLoad: function(errorOccurred){
			if(!errorOccurred){
				this.updateBubbleHighlighting()
			}
		},

		updateBubbleHighlighting: function(){
			var highlightTagBubbles = ((this.model.resourceFilters || {}).filters || {}).tags || [];
			this.$.find('.fieldOf_tags .bubble').removeClass('highlighted');
			if(highlightTagBubbles.length > 0){
				this.$.find(highlightTagBubbles.map(tagKey => `.fieldOf_tags .bubble[data-tag-key="${tagKey}"]`).join(',')).addClass('highlighted');
			}
		},
	},

	hooks: {
		_attach: function($element, options){
			this.updateBubbleHighlighting()
		},
	},
}
